import React from "react";
import { useSession } from "../../Session";
import {
  Badge,
  Banner,
  Button,
  Container
} from "./styled/presentations-banner";

export default function PresentationBanner() {
  const { features } = useSession();

  if (!features.hasPresentations) {
    return null;
  }

  return (
    <Container>
      <Banner>
        <Badge>New Feature</Badge>
        <div>
          Try Presentations! Create stunning presentations directly in Cloud CMA
        </div>
        <Button
          href="https://share.vidyard.com/watch/fcFsu6AvCpNLUmcGm3PLQZ"
          rel="noopener noreferrer"
          target="_blank">
          Learn More →
        </Button>
      </Banner>
    </Container>
  );
}
